import React from 'react';
import { useDiContainer, useGlobalErrorsManager } from '../../hooks';
import { Reflector } from '../../reflection';
import { ControllerWrapper } from './ControllerWrapper';
import { ErrorBoundary } from './ErrorBoundary';
import { Guards } from './Guards';
export var RouteWrapper = function RouteWrapper(_ref) {
  var Controller = _ref.Controller;
  var container = useDiContainer();
  var globalErrorsManager = useGlobalErrorsManager();

  var _Reflector$getControl = Reflector.getControllerMetadata(Controller),
      _Reflector$getControl2 = _Reflector$getControl.guards,
      guards = _Reflector$getControl2 === void 0 ? [] : _Reflector$getControl2,
      _Reflector$getControl3 = _Reflector$getControl.handlers,
      handlers = _Reflector$getControl3 === void 0 ? [] : _Reflector$getControl3;

  var eh = handlers.map(function (v) {
    return typeof v === 'function' ? container.resolveDepsSync(v) : v;
  });
  var gs = guards.map(function (G) {
    return container.resolveSync(G);
  });
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    name: Controller.name,
    globalErrorsManager: globalErrorsManager,
    handlers: eh
  }, /*#__PURE__*/React.createElement(Guards, {
    guards: gs
  }, /*#__PURE__*/React.createElement(ControllerWrapper, {
    Controller: Controller
  })));
};